const LanguagesIcon = ({ size = 24, ...props }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M2.25 5.25H15.75"
                stroke="#0069AD"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.5 18L17.5 11L14 18H20.5Z"
                fill="#BBD8ED"
            />
            <path
                d="M9 3V5.25"
                stroke="#0069AD"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.75 21L17.25 10.5L21.75 21"
                stroke="#00A7E4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.1328 18H20.3672"
                stroke="#00A7E4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.1859 5.25C13.1859 5.25 12.0469 9.65625 9.32812 12.9844C6.60938 16.3125 3.75 18 3.75 18"
                stroke="#0069AD"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 15.75C12 15.75 10.3594 14.4844 8.625 12.2344C6.89062 9.98438 6 8.25 6 8.25"
                stroke="#0069AD"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LanguagesIcon;